export default "__VITE_ASSET__uiHsqZyR__"